import { EntitiesStore } from './entities-store.abstract';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap, mergeMap, filter, map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { EventGeneralInfoItem } from 'world-archery-lib';
import { WaHelperService } from '../../../library/wa-services/wa-helper-service';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';
import { CategoryCombo, RegionCombo, ComboStoreComponent } from '../filters-store/filters-store';
import { IMemberAssociation } from './member-association-store';
import { ActivatedRoute } from '@angular/router';


/**
 * The IContinentalRanking athlete.
 *
 * @export
 * @interface IContinentalRankingAthlete
 */
export interface IContinentalRankingAthlete {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  NOC: string;
}

/**
 * The IContinentalRanking interface.
 *
 * @export
 * @interface IContinentalRanking
 */
export interface IContinentalRanking {
  Rnk: number;
  RnkOld: number;
  Cat: string;
  Points: number;
  RnkDtIssued: string;
  RnkDtSince: string;
  Athlete: IContinentalRankingAthlete;
}

/**
 * Continental ranking store.
 *
 * @export
 * @class ContinentalRankingStore
 * @extends {ContinentalRankingStore<IContinentalRanking>}
 */
export class ContinentalRankingStore extends EntitiesStore<IContinentalRanking> {
  constructor(http: HttpClient, injector: Injector) {
    super('CONTINENTALRANKINGS', http, [
      { entity: new CategoryCombo('', '', http), params:{'RBP': 'All'} },
    ]);
  }
}


export interface IContinentalCategory{
  Team: boolean;
  Cat: string;
}

/**
 * Continental category ranking store.
 *
 * @export
 * @class ContinentalRankingCategoriesStore
 * @extends {ContinentalRankingStore<IContinentalRanking>}
 */
 export class ContinentalRankingCategoriesStore extends ComboStoreComponent<IContinentalRanking> {
  constructor(id:string, name:string,http: HttpClient, injector: Injector) {
    super(name, 'Name', id,  undefined, undefined, http, 'CONTINENTALRANKINGSCATEGORIES', [], [
      { entity: new CategoryCombo('', '', http), params:{'RBP': 'All'} },
    ], true, 'category');
  }

  getRequest(params: any, request_more: boolean = false){
    return super.getRequest(params, request_more).pipe(
      map(a=> {
        const categoriesDependency = this.dependencies[0].entity.data;
        const filteredCategories = categoriesDependency
        .filter(value=> (a as any).items.findIndex(continentalCategory => continentalCategory.Cat === value.Code)> -1);
        this.data = filteredCategories;
        (a as any).items = this.data;
        this.comboInfo.options_subject.next(this.data);
        this.comboInfo.options_selected_subject.next(this.data[0]);
        return a;
      })
    )
  }
}


/**
 * The combo discipline interface for continental rankings.
 *
 * @export
 * @interface IComboDiscipline
 */
export interface IComboDiscipline{
  Name: string;
  Value: boolean;
}


/**
 * Combo for discipline of rankings (Outdoor/Para)
 *
 * @export
 * @class HistoricalComboAthlete
 * @extends {ComboStoreComponent<IYesNoCombo>}
 */
 export class DisciplineComboStore extends ComboStoreComponent<IComboDiscipline> {
  constructor(name_filter, id, initialState?: IComboDiscipline) {
    super(name_filter, "Name", id, undefined, undefined, undefined, undefined, [
      { item: { Name: "Outdoor", Value: false }, position: 0 },
      { item: { Name: "Para", Value: true }, position: 1 }
    ], undefined, undefined, 'discipline');
    if (initialState) {
      this.comboInfo.initial_state = true;
      this.comboInfo.options_selected_subject.next(initialState);
    }
  }
}


/**
 * The combo store for continental ranking categories.
 *
 * @export
 * @class CountryContinentComboStore
 * @extends {ComboStoreComponent<IMemberAssociation>}
 */
export class CountryContinentComboStore extends ComboStoreComponent<IMemberAssociation>{
  constructor(name_filter, id, injector:Injector, initialState?: IComboDiscipline) {
    super(name_filter, "CShort", id, undefined, undefined, injector.get(HttpClient), 'MEMBERASSOCIATIONS', [{
      item : {
        CShort: 'All'
      } as any, position:0

    }], [], true, 'country');
    if (initialState) {
      this.comboInfo.initial_state = true;
      this.comboInfo.options_selected_subject.next(initialState);
    }
    this.filterInfo.options.withTextSearch = true;
    this.filterInfo.options.renderFunc = (value) => {
      return `
      <div style="display:flex;    justify-content: flex-end;">
      <div class="">

      ${value.CShort}
    </div>
      <div style="margin-left:10px; class="country__img" >
      <div style="margin-left:10px; width:20px; height:20px;">
      ${value.NOC ? `<img style="width: 20px;
      height: 20px;" src="//extranet.worldarchery.sport/Flags/${value.NOC}.svg" />` : ''}
      </div>

  </div>
  </div>` as any;
    }
    if (true) {
      this.filterInfo.options.renderFuncSelected =  (value) => {
        value = typeof value === 'string' ? JSON.parse(value) : value;

        return `
        <div style="display:flex;    justify-content: flex-end; align-items:center;">
        <div class="">

        ${value.CShort}
      </div>
      ${value.NOC ? `<div class="country__img" >
        <div style="margin-left:10px; width:20px; height:20px;">
        <img style="width: 20px;
        height: 20px;" src="//extranet.worldarchery.sport/Flags/${value.NOC}.svg" />` : ''}
        </div>

    </div>
    </div>` as any;
      }
    }

  }

}

/**
 * The individual combo store for continental rankings.
 *
 * @export
 * @class IndividualTeamComboStore
 * @extends {ComboStoreComponent<IComboDiscipline>}
 */
export class IndividualTeamComboStore extends ComboStoreComponent<IComboDiscipline> {
  constructor(name_filter, id, initialState?: IComboDiscipline) {
    super(name_filter, "Name", id, undefined, undefined, undefined, undefined, [
      { item: { Name: "Individual", Value: false }, position: 0 },
      { item: { Name: "Team", Value: true }, position: 1 }
    ], undefined, undefined, 'event');
    if (initialState) {
      this.comboInfo.initial_state = true;
      this.comboInfo.options_selected_subject.next(initialState);
    }
  }
}
